<template>
  <ModalDialog
    ref="dialog"
    title="Myob Relink Contact"
    icon="fa-id-card-alt"
    :submitting="submitting"
    submitTitle="Relink"
    :submitDisabled="submitDisabled"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="myobForm" :labelColumnSize="3">
      <LoadingPanel ref="loadingPanel" @update="loading = $event" :loadingError="loadingError" />

      <div v-show="!loading && !loadingError">
        <NotificationBar type="warning">
          <NotificationBarTitle>This will relink the Synergy Contact with a specific MYOB Contact</NotificationBarTitle>
            <ul>
              <li>All invoices / payments / credit notes already synced with MYOB will not change contact in MYOB</li>
              <li>Only future invoices / payments / credit notes will be synced to the new MYOB contact</li>
            </ul>
        </NotificationBar>

        <FormRow label="MYOB Contact">
          <FormSearchableSelect :options="myobContactLookup" v-model="selectedMyobContactId" />
        </FormRow>
      </div>

    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import IntegrationMyobAPIService from '@/integrations/myob/services/apiService'

export default {
  name: 'MyobContactRelinkDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    contactId: Number,
    myobContactID: String    
  },
  data() {
    return {
      myobForm: {},
      loading: true,
      loadingError: '',
      submitting: false,

      selectedMyobContactId: this.myobContactID || '',
      myobContactList: []
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {
    myobContactLookup() {
      return this.myobContactList.map(myobContact => {
        return {
          name: myobContact.name,
          value: myobContact.contactID
        }
      })
    },
    submitDisabled() {
      return this.myobContactLookup.find(item => item.value == this.selectedMyobContactId) == null
    }
  },
  methods: {
    show() {
      // Reset form
      this.myobForm = {}
      this.submitting = false

      this.requestData()

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      var myobService = new IntegrationMyobAPIService(this.$api)

      this.submitting = true
      this.myobForm = this.clearFormResponse()
      
      let relinkData = {
        myobContactID: this.selectedMyobContactId
      }

      myobService.relinkContact(this.contactId, relinkData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
        this.successToast('Myob Contact Relinked')
      })
      .catch(err => {
        this.myobForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })

    },
    requestData() {
      var myobService = new IntegrationMyobAPIService(this.$api)

      this.$refs.loadingPanel.startLoading()
      myobService.getMyobContactList()
      .then(response => {
        this.myobContactList = response.data
      })
      .catch(err => {
        this.$refs.loadingPanel.setError('Error accessing Myob contact list', err)
      })
      .finally(() => {
        this.$refs.loadingPanel.finishedLoading()
      })
    }
  }
}
</script>
